var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDriversCardHover(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "conductores_main",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_205",
    "data-name": "Rect\\xE1ngulo 205",
    width: 50,
    height: 50,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_27",
    "data-name": "Rect\\xE1ngulo 27",
    width: 41.356,
    height: 43.268,
    fill: "#6e931b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_19",
    "data-name": "Enmascarar grupo 19",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_26",
    "data-name": "Grupo 26",
    transform: "translate(4.322 3.366)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25",
    "data-name": "Grupo 25",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_41",
    "data-name": "Trazado 41",
    d: "M0,38.789c.108-.819.187-1.644.33-2.458A20.586,20.586,0,0,1,15.556,20.017c.095-.024.186-.06.318-.1a10.468,10.468,0,0,1-5.683-9.186,10.078,10.078,0,0,1,3.18-7.737,10.535,10.535,0,1,1,12.214,16.9c.883.293,1.789.53,2.644.888,7.222,3.026,11.582,8.37,12.921,16.111a11.779,11.779,0,0,1,.171,3.02,3.716,3.716,0,0,1-3.109,3.283,1.068,1.068,0,0,0-.188.076H31.349c-.09-.03-.179-.066-.271-.089A3.792,3.792,0,0,1,28.147,40.3c-.028-.1-.051-.208-.088-.363L26.2,41.011c.276,1.372.173,1.662-.77,2.257h-.676a1.676,1.676,0,0,1-.983-1.389,3.115,3.115,0,0,0-6.138-.016,1.63,1.63,0,0,1-1.075,1.4h-.422c-.5-.174-.971-.43-1.023-1a10.341,10.341,0,0,1,.088-1.576l-1.833-1.06c-.018.14-.027.235-.042.33a3.748,3.748,0,0,1-2.912,3.185c-.2.046-.41.081-.615.121H3.3c-.09-.029-.179-.066-.271-.088A3.631,3.631,0,0,1,.505,41.3,10.113,10.113,0,0,1,0,39.888v-1.1m34.917,1.917c.093.01.134.018.176.018.76,0,1.521,0,2.281,0a1.337,1.337,0,0,0,1.467-1.584,26.822,26.822,0,0,0-.594-3.785A18.135,18.135,0,0,0,18.9,22.007,17.654,17.654,0,0,0,7.517,27.591a17.655,17.655,0,0,0-4.968,11.7,1.275,1.275,0,0,0,1.386,1.435c.718,0,1.436,0,2.154,0,.134,0,.268-.013.391-.019V38.194c-.225,0-.421.006-.616,0a1.286,1.286,0,0,1-1.3-1.283A1.27,1.27,0,0,1,5.89,35.661c.605-.007,1.212-.025,1.816.007a.724.724,0,0,0,.739-.4A14.532,14.532,0,0,1,23.286,28.8a14.385,14.385,0,0,1,9.748,6.58.547.547,0,0,0,.543.287c.661-.017,1.323-.013,1.985,0a1.261,1.261,0,0,1,1.277,1.249,1.28,1.28,0,0,1-1.212,1.277c-.233.017-.468,0-.709,0ZM17.539,3.238a7.967,7.967,0,0,0,5.257,15,7.834,7.834,0,0,0,5.834-8.145A8.341,8.341,0,0,1,17.539,3.238m12.65,32.534A11.949,11.949,0,0,0,11.4,35.557l2.554,1.48,2.581,1.5c.137-.126.249-.231.363-.334a5.666,5.666,0,0,1,7.855.254.44.44,0,0,0,.662.088c1.583-.938,3.18-1.852,4.769-2.771M20.025,2.609a5.683,5.683,0,0,0,2.914,4.657,5.564,5.564,0,0,0,5.133.279,7.844,7.844,0,0,0-8.047-4.937M9.073,38.217v2.466a1.461,1.461,0,0,0,1.531-.506,1.259,1.259,0,0,0,.043-1.4c-.351-.611-.937-.634-1.575-.565m23.27.006a1.42,1.42,0,0,0-1.561.571,1.227,1.227,0,0,0,.064,1.418,1.348,1.348,0,0,0,1.5.449Z",
    transform: "translate(0 0)",
    fill: "#6e931b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDriversCardHover);
export default __webpack_public_path__ + "static/media/icon_drivers_card_hover.916d5466455e1ef20e96159f35ecad87.svg";
export { ForwardRef as ReactComponent };